// The SOLE client-side safeguard against rendering another thread's chat.
//
// The OpenClaw WS gateway BROADCASTS every "chat" event (deltas + finals) to
// ALL connected clients holding the operator.read scope — which is every Holler
// webchat (see gateway/connection.ts). The server does NOT scope chat frames by
// thread_acl, so the ONLY thing stopping a user from rendering a Foreman reply
// for a thread they aren't viewing is the equality gate below. Keep it pure and
// tested so a refactor can never silently drop it. (See scratchpad chat-p2 /
// the P2 options doc for the durable server-side fix.)

/** OpenClaw emits event keys like "agent:main:KEY"; the short key — everything
 *  after the 2nd colon — is what matches the client's activeSessionId. Keys
 *  without a colon (and the empty/absent case → "main") pass through unchanged. */
export function normalizeSessionKey(raw?: string | null): string {
  const s = raw || 'main';
  return s.includes(':') ? (s.split(':').slice(2).join(':') || s) : s;
}

/** True iff a broadcast chat frame belongs to the currently-open thread. A null
 *  active session (no thread open) matches nothing — every frame is dropped. */
export function matchesActiveSession(
  rawSessionKey: string | null | undefined,
  activeSessionId: string | null,
): boolean {
  if (!activeSessionId) return false;
  return normalizeSessionKey(rawSessionKey) === activeSessionId;
}
